  <template>
    <div class="menu">
        <div class="center examplex d-flex">
            <vs-navbar center-collapsed v-model="active" :key="componentKey">
                <div v-for="(menuOpciones, i) in menu" :key="i">
                    <vs-navbar-group v-if="menuOpciones.length > 1">
                        <span class="text-uppercase">{{i}}</span>
                        <template #items>
                            <vs-navbar-item @click="menuSelect(opciones)" :href="submenu[opciones] ? submenu[opciones].ruta : false" v-for="(opciones, j) in menuOpciones" :key="j" :active="active == opciones" :id="opciones" >
                                <template v-if="submenu[opciones].nombre == 'Gestión de cobranza' && !verFinanzas">
                                    Cargando
                                </template>
                                <template v-else>
                                    {{submenu[opciones] ? submenu[opciones].nombre : ''}}
                                </template>
                            </vs-navbar-item>
                        </template>
                    </vs-navbar-group>
                    <vs-navbar-item v-else @click="menuSelect(menuOpciones[0])" :href="submenu[menuOpciones[0]] ? submenu[menuOpciones[0]].ruta : false" :active="active == menuOpciones[0]" :id="menuOpciones[0]">
                        <span class="text-uppercase">{{submenu[menuOpciones[0]] ? submenu[menuOpciones[0]].nombre : ''}}</span>
                    </vs-navbar-item>
                </div>
                <vs-navbar-item v-if="personaRol.tipoUserPrincipal == 'Personal central - TI'">
                    <span class="text-uppercase" @click="menuSelect('bajas-alumno')">BAJAS PROTOTIPO</span>
                </vs-navbar-item>
            </vs-navbar>
        </div>
    </div>
</template>


<script>
export default {
    props:[
        'menuPermisos',
        'general',
        'personaRol',
        'ruta_url',
        'filtrosPadresFinanzas'
    ],
    data(){
        return{
            active: '',
            submenu: {
                'perfil': {
                    nombre: 'Perfil',
                    ruta: false
                },
                'gestion-de-accesos': {
                    nombre: 'Gestión de accesos',
                    ruta: false
                },
                'datos-medicos': {
                    nombre: 'Datos médicos',
                    ruta: false
                },
                'familiares': {
                    nombre: 'Familiares',
                    ruta: false
                },
                'datos-referenciales': {
                    nombre: 'Datos referenciales',
                    ruta: false
                },
                'ver-finanzas-alumno': {
                    nombre: 'Finanzas',
                    ruta: false
                }, 
                'gestion-finanzas': {
                    nombre: 'Gestión de cobranza',
                    ruta: false
                }, 
                'gestion-finanzas-v1': {
                    nombre: 'Gestión de cobranza v1',
                    ruta: false
                }, 
                'datos-fiscales': {
                    nombre: 'Datos fiscales',
                    ruta: false
                },
                'bajas-suspensiones': {
                    nombre: 'Bajas y suspensiones',
                    ruta: false
                },
                'bajas-alumno': {
                    nombre: 'Bajas alumno TI',
                    ruta: false
                },
                'becas': {
                    nombre: 'Becas',
                    ruta: false
                }, 
                'inscripcion-academica': {
                    nombre: 'Inscripción académica',
                    ruta: false
                },
                'expediente-digital': {
                    nombre: 'Expediente digital',
                    ruta: false
                },
                'ver-calificaciones': {
                    nombre: 'Calificaciones',
                    ruta: false
                },
                'proceso-de-admision': {
                    nombre: 'Proceso de admisión',
                    ruta: false
                },
                'mapa-carga-academica': {
                    nombre: 'Mapa de carga académica',
                    ruta: false
                },
                'historico-correos': {
                    nombre: 'Historico de correos',
                    ruta: false
                },
                'descargar-material': {
                    nombre: 'Descargar material',
                    ruta: false
                }
            },
            menu: {},
            verFinanzas: false,
            componentKey: 0
        }
    },
    methods: {
        activeMenu(){
            if(this.general.proceso == 'alumno'){
                // this.active = 'perfil'
                if(this.ruta_url){
                    this.active = this.ruta_url
                }else{
                    this.active = 'perfil'
                }
            }else if(this.general.proceso == 'seguimiento'){
                // this.active = 'proceso-de-admision'
                if(this.ruta_url){
                    this.active = this.ruta_url
                }else{
                    this.active = 'proceso-de-admision'
                }
            }
        },
        doMenu(){
            let menu = {
                procesoAdmision: [],
                general:[],
                finanzas: [],
                academicos: [],
                calificaciones: []
            }
            const vm = this
            const general = this.general.permisos
            // const roles = JSON.parse(this.personaRol)
            const roles = this.personaRol
            
            general.forEach(element => {
                // PERFIL 
                if(['historico-correos', 'perfil'].includes(element)){
                    menu.general.push(element)
                }else if(element == 'familiares' && !['prospecto'].includes(roles.tipoUserPrincipal)){
                    menu.general.push(element)
                }else if(element == 'datos-medicos' && vm.general.datos.tipo != 'prospecto'){
                    menu.general.push(element)
                }else if(element == 'datos-referenciales' && vm.general.datos.tipo != 'prospecto'){
                    menu.general.push(element)
                }else if(element == 'gestion-de-accesos' && roles.roles[0].name != 'Usuario Principal' && !['alumno', 'prospecto'].includes(roles.tipoUserPrincipal)){
                    menu.general.push(element)
                }
                // FINANZAS
                else if( element == 'ver-finanzas-alumno' && vm.general.datos.persona_id){
                    menu.finanzas.push(element)
                }else if(element == 'gestion-finanzas' && roles.roles[0].name != 'Usuario Principal' && vm.general.datos.persona_id){
                    menu.finanzas.push(element)
                    if(roles.roles[0].name == 'Personal central - TI'){
                        menu.finanzas.push('gestion-finanzas-v1')
                    }
                }else if(element == 'datos-fiscales' && (!['alumno', 'prospecto'].includes(roles.tipoUserPrincipal) || ([5, 25, 28].includes(this.general.datos.institucionId)))){
                    menu.finanzas.push(element)
                }
                // ACADEMICOS
                else if(['bajas-suspensiones'].includes(element) && (vm.general.datos.tipo == 'alumno' || vm.general.datos.tipo == 'persona') && roles.roles[0].name != 'Usuario Principal'){
                    menu.academicos.push(element)
                }else if(element == 'becas' && (vm.general.datos.tipo == 'alumno' || vm.general.datos.tipo == 'persona') && roles.roles[0].name != 'Usuario Principal'){
                    menu.academicos.push(element)
                }else if(element == 'expediente-digital' && (vm.general.datos.tipo == 'alumno' || vm.general.datos.tipo == 'persona')){
                    menu.academicos.push(element)
                }else if(element == 'inscripcion-academica' && ((vm.general.datos.tipo == 'alumno' || vm.general.datos.tipo == 'persona') || ([5,8]).includes(vm.general.datos.status_id))){
                    menu.academicos.push(element)
                }else if(element == 'mapa-carga-academica' && roles.tipoUserPrincipal == 'Personal central - TI' && (vm.general.datos.tipo == 'alumno' || vm.general.datos.tipo == 'persona')){
                    menu.academicos.push(element)
                }else if(element == 'descargar-material' && (vm.general.datos.tipo == 'alumno' || vm.general.datos.tipo == 'persona')){
                    menu.academicos.push(element)
                }
                // CALIFICACIONES
                else if(['ver-calificaciones'].includes(element) && (vm.general.datos.tipo == 'alumno' || vm.general.datos.tipo == 'persona') && vm.general.datos.persona_id){
                    menu.calificaciones.push(element)
                }
                // PROCESO DE ADMISIÓN
                else if(element == 'proceso-de-admision' && vm.general.datos.tipo != 'alumno'){
                    menu.procesoAdmision.push(element)
                }
            });
            this.menu = menu
        },
        menuSelect(opcion){
            // OPCIONES QUE SON LINK EXTERNO
            // if(!['mapa-carga-academica'].includes(opcion)){
                this.active = ''
                this.active = opcion
                
            if(opcion != 'gestion-finanzas'){
                this.$emit('opcionMenu', this.active)    
            } 
            // }
            if(opcion == 'gestion-finanzas' && this.verFinanzas){
                const url = window.location.origin;
                const estadoCuenta = url + '/estado-de-cuenta/' + this.general.idAlumno + '/gestion?institucion_id=' + this.filtrosPadresFinanzas.institucion + '&ciclo_escolar_id=' + this.filtrosPadresFinanzas.cicloEscolar
                window.open(estadoCuenta, '_self')
            }
        },
        rutaExterna(){
            // MANDAR A LA RUTA DEL LINK EXTERNO
            // this.submenu['gestion-finanzas'].ruta = '/finanzas/admin/' + window.btoa(this.general.datos.persona_id)
            // this.submenu['ver-finanzas-alumno'].ruta = '/finanzas/' + window.btoa(this.general.datos.persona_id)
            // this.submenu['ver-calificaciones'].ruta = '/alumno-calificaciones/getBoleta/' + window.btoa(this.general.datos.persona_id)
            // this.submenu['inscripcion-academica'].ruta = '/proceso-inscripcion/persona/' + window.btoa(this.general.datos.persona_id)
            // this.submenu['expediente-digital'].ruta = '/expedienteDigital/' + window.btoa(this.general.datos.persona_id)
            // this.submenu['mapa-carga-academica'].ruta = '/proceso-inscripcion/mapa-inscripcion-materias/' + window.btoa(this.general.datos.persona_id)
        },
        refreshComponent() {
            this.componentKey++; 
        }
    },
    watch: {
        general(){
            this.doMenu()
            // this.rutaExterna()
            this.activeMenu()
        },
        filtrosPadresFinanzas(){
            this.verFinanzas = true
            this.refreshComponent()
        }
    }
}
</script>

<style lang="scss" scoped>
.menuRol .shadow-sm{
    text-align: center;
}

.vs-navbar-content{
    position: relative !important;
    z-index: 9 !important;
}
</style>